module.exports = __webpack_public_path__ + "static/media/venge.76aaed8a.jpg";